const iconTypeNames = [
    'viewSide', 'viewSideUp',
    'close', 'open',
    'edit', 'save', 'cancel',
    'checkMark',
    'search', 'research', 'layout', 'form', 'extract', 'import',
    'combine', 'editDetails', 'createFrom', 'create', 'searchSuggest',
    'changes', 'changesCancel', 'changesReopen', 'changesReject', 'changesAccept', 'changesComplete', 'changesTrack',
    'commentReopen', 'play', 'pause', 'stop',
    'approve', 'reject', 'history',
    'location', 'link',
    'eye', 'lock', 'password', 
    'document', 'copy', 'paste', 'upload', 'download', 'openLink',
    'leftArrow'
] as const;

type IconType = typeof iconTypeNames[number];
type IconsType = { [key in IconType]: any };

export const CerUiIcons: IconsType = {
    // Fluent
    viewSide: 'e-icons-fluent e-view-side-right',
    viewSideUp: 'e-icons-fluent e-view-side-up',

    // Std
    close: 'e-icons e-close',
    open: 'e-icons e-open',
    checkMark: 'e-icons-org e-check',
    edit: 'e-icons e-edit',
    cancel: 'e-icons e-cancel',
    save: 'e-icons e-save',

    search: "e-icons-org e-search",
    research: "e-icons-org e-research",
    layout: "e-icons-org e-print-layout",
    form: "e-icons-org e-text-form",
    extract: "e-icons-org e-copy2",
    import: 'e-icons-fluent e-import',
    combine: 'e-icons-org e-table-update',

    editDetails: 'e-icons-org e-changes-track',
    createFrom: 'e-icons-org e-copy-1',
    create: 'e-icons-org e-file-new',
    searchSuggest: 'e-icons-org e-search-2',
    changes: 'e-icons-org e-changes-next',
    changesCancel: 'e-icons-org e-changes-previous',
    changesReopen: 'e-icons-org e-comment-reopen',
    changesReject: 'e-icons-org e-changes-reject',
    changesAccept: 'e-icons-org e-changes-accept',
    changesComplete: 'e-icons-org e-table-update',
    changesTrack: 'e-icons-org e-changes-track',
    commentReopen: 'e-icons-org e-comment-reopen',

    play: 'e-icons.org e-play',
    pause: 'e-icons.org e-pause',
    stop: 'e-icons-org e-circle-close-2',

    approve: 'e-icons-org e-thumbs-up',
    reject: 'e-icons-org e-thumbs-down',
    history: 'e-icons-org e-history',

    location: 'e-icons-org e-location',
    link: "e-icons e-hyperlink-open",

    eye: "e-icons-org e-eye",
    lock: "e-icons-org e-lock",
    password: "e-icons-org e-password",

    document: 'e-icons e-download', //e-file-document',
    copy: 'e-icons e-copy',
    paste: 'e-icons e-paste',
    upload: 'e-icons e-upload-1',
    download: 'e-icons e-download',
    openLink: 'e-icons e-open-link',

    leftArrow: 'e-icons-org e-chevron-left'
};


